<template>
  <section>
    <div class="custom-message-count" title="unread meassages">
      <a @click="onClick">
        <span>{{ count }}</span>
        <i
          class="fas fa-comment"
          :class="{ 'custom-highlight': isHighlight }"
        ></i>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: 'message-count',
  props: {
    count: {
      type: [Number, String],
      default: 0,
    },
    id: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isHighlight() {
      let _is = false
      if (this.count) {
        if (parseInt(this.count) > 0) {
          _is = true
        }
      }
      return _is
    },
  },
  methods: {
    onClick() {
      this.$emit('clicked', this.id)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-message-count {
  padding: 5px;
  a {
    text-decoration: none;
    cursor: pointer;
  }
  a:hover {
    outline: none;
    text-decoration: none;
    color: #72afd2;
    text-shadow: 0 0 3px #0026ff;
  }
  i {
    position: relative;
    top: -8px;
    font-size: 1.2em;
    color: rgb(184, 184, 184);
    margin-left: 5px;
  }
}
.custom-highlight {
  // color: rgba(255, 244, 87) !important;
  color: rgb(243, 146, 0) !important;
}
</style>
